module.exports = __webpack_public_path__ + "img/gb9123_26_d.prt.66440f48.jpg";